export default function useCurrentTeam() {
  return window.Bonjoro.team;
}
